export default __webpack_public_path__ + "static/media/delivery.6677fb0a.gif";